import type { IconNode } from '../types';

/**
 * @name germ-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTEgMiAuOTI1IDEuODQ4IiAvPgogIDxwYXRoIGQ9Ik0xMyAxNWguMDEiIC8+CiAgPHBhdGggZD0iTTEzLjQyNCA3Ljc2OGEyIDIgMCAxMTIuODA4IDIuODA4IiAvPgogIDxwYXRoIGQ9Im0xNiAyMS0xLTIuNDcyIiAvPgogIDxwYXRoIGQ9Ik0xNi45ODggMTYuOTg4QTEyIDEyIDAgMDE5IDIwYTUgNSAwIDAxLTIuNzU5LTkuMTcxIDguOCA4LjggMCAwMDIuMzA3LTIuMjgiIC8+CiAgPHBhdGggZD0ibTE5IDItMSAxLjgwNCIgLz4KICA8cGF0aCBkPSJtMiAxOSAyLjc0Ni0xLjM3MyIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Im0yMiAxNi0yLjQ3NC0yLjEzYTEyIDEyIDAgMDAxLjM3Ni0zLjc4NiA2IDYgMCAwMC0xMC4zMTMtNS4xNTEiIC8+CiAgPHBhdGggZD0ibTIyIDUtMS44MDQgMSIgLz4KICA8cGF0aCBkPSJtMyAxMCAyIDIiIC8+CiAgPHBhdGggZD0iTTkgMTZoLjAxIiAvPgogIDxwYXRoIGQ9Ik05IDIwdjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/germ-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const GermOff: IconNode = [
  ['path', { d: 'm11 2 .925 1.848' }],
  ['path', { d: 'M13 15h.01' }],
  ['path', { d: 'M13.424 7.768a2 2 0 112.808 2.808' }],
  ['path', { d: 'm16 21-1-2.472' }],
  ['path', { d: 'M16.988 16.988A12 12 0 019 20a5 5 0 01-2.759-9.171 8.8 8.8 0 002.307-2.28' }],
  ['path', { d: 'm19 2-1 1.804' }],
  ['path', { d: 'm2 19 2.746-1.373' }],
  ['path', { d: 'm2 2 20 20' }],
  ['path', { d: 'm22 16-2.474-2.13a12 12 0 001.376-3.786 6 6 0 00-10.313-5.151' }],
  ['path', { d: 'm22 5-1.804 1' }],
  ['path', { d: 'm3 10 2 2' }],
  ['path', { d: 'M9 16h.01' }],
  ['path', { d: 'M9 20v2' }],
];

export default GermOff;
